import { AlertTriangle, Clock } from "lucide-react";
import { MAINTENANCE } from "@config/maintenance";
import logo from "../../../../assets/img/logo/transparent_logo.png";

export function MaintenanceMode() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-slate-900">
      <div className="flex flex-col items-center space-y-6 text-white">
        <div className="flex w-[250px] justify-center">
          <img src={logo} alt="logo" width="250" />
        </div>
        <div className="px-4 text-center lg:w-[350px]">
          <div className="space-y-6">
            <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-amber-100">
              <AlertTriangle className="size-8 text-amber-600" />
            </div>

            <h1 className="text-2xl font-bold text-white">Maintenance en cours</h1>

            <p className="text-lg text-slate-300">Le site est temporairement indisponible pour une migration.</p>

            <div className="flex items-center justify-center space-x-2 text-blue-400">
              <Clock className="size-5" />
              <span className="font-semibold">Retour prévu à {MAINTENANCE.returnTime}</span>
            </div>

            <p className="text-sm text-slate-400">Nous nous excusons pour la gêne occasionnée.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
